class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  disconnectedCallback() {
    clearTimeout(this.focusTimer);
    this.cancelMobileTransition?.();
    if (ridoraDrawer.owners.has(this)) {
      document.body.classList.remove("overflow-hidden");
      ridoraDrawer.unlock(this);
      if (!ridoraDrawer.owners.size) removeTrapFocus();
    }
  }

  open(triggeredBy) {
    this.cancelMobileTransition?.();
    this.classList.remove("ridora-closing");
    if (ridoraDrawer.mobile()) ridoraDrawer.lock(this);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    this.classList.add("animate", "active");
    document.body.classList.add("overflow-hidden");
    const focusDrawer = () => {
      if (!this.classList.contains("active")) return;
      const container = this.classList.contains("is-empty")
        ? this.querySelector(".drawer__inner-empty")
        : this.querySelector(".drawer__inner");
      if (container)
        trapFocus(container, container.querySelector("button, a") || container);
    };
    clearTimeout(this.focusTimer);
    if (ridoraDrawer.owners.has(this)) {
      this.cancelMobileTransition = ridoraDrawer.after(
        this.querySelector(".drawer__inner"),
        () => {
          requestAnimationFrame(() => requestAnimationFrame(focusDrawer));
        },
      );
      // Safari can defer visibility during a tap even with zero-duration motion.
      this.focusTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) focusDrawer();
      }, 350);
      return;
    }
    requestAnimationFrame(() => requestAnimationFrame(focusDrawer));
    // Also cover a drawer opened during a product section replacement.
    this.focusTimer = setTimeout(focusDrawer, 350);
  }

  close() {
    clearTimeout(this.focusTimer);
    if (ridoraDrawer.owners.has(this)) {
      this.cancelMobileTransition?.();
      this.classList.add("ridora-closing");
      this.classList.remove("active");
      this.cancelMobileTransition = ridoraDrawer.after(
        this.querySelector(".drawer__inner"),
        () => {
          this.classList.remove("ridora-closing");
          document.body.classList.remove("overflow-hidden");
          ridoraDrawer.unlock(this);
          if (!ridoraDrawer.owners.size)
            removeTrapFocus(this.activeElement, { preventScroll: true });
        },
      );
      return;
    }
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (
      this.getSectionsToRender().some(
        (section) => !parsedState.sections?.[section.id],
      )
    ) {
      window.location.assign(window.routes.cart_url);
      return;
    }
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
